module.exports = __webpack_public_path__ + "media/bootstrap-icons/wifi-2-994d85e1.svg";